"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.VehiclesCompareSectionReducers = exports.VehiclesCompareSection = void 0;

var _vehicleCompareContainer = _interopRequireDefault(require("./components/containers/vehicle-compare-container"));

exports.VehiclesCompareSection = _vehicleCompareContainer["default"];

var _reducers = require("./redux/reducers");

exports.VehiclesCompareSectionReducers = _reducers.VehiclesCompareSectionReducers;